import { ISubject } from "@/Interfaces/subject";
import {
  LargeHeadingStyled,
  SectionHeaderStyled,
  SmallHeadingStyled,
} from "../../../components/custom/texts/texts.styled";
import { Box, Card, Flex, Icon } from "@nubeteck/components";
import { Button, Form, Image, Layout, Modal, Select, Table, Skeleton } from "antd";
import { ColumnsType } from "antd/es/table";
import React, { useEffect, useState } from "react";
import {
  useChangeSubjectMutation,
  useGetCurrentSubjectsDetailMutation,
  useGetCancellationInfoMutation,
  useGetSubjectsForChangeMutation,
  useGetWithdrawMessageMutation,
  useWithdrawSubjectMutation,
  useWithdrawEnrollmentByStudentMutation,
} from "src/services/subjectsServices";
import toast from "react-hot-toast";
import { NoResultsSVG } from "src/assets";
import {
  toastErrorStyle,
  useErrorSelectWithdrawalReasonToast,
  useErrorSelectPeriodToast,
  useSuccessSubjectWithdrawnToast,
  useSuccessEnrollmentCancelledToast,
  useSuccessSectionChangedToast,
} from "src/constants";
import { useGetResolutionsMutation } from "src/services";
import { ArrayUtils } from "@nubeteck/utils";
import { SubjectTableSchedule } from "src/components";
import { FormatterUtils } from "@nubeteck/utils";
import { ButtonAlternativeStyled } from "src/components/custom/buttons/buttons.styled";
import { getEnrolledSubjectPage } from "../../../Api/content";
import { useLocale } from "../../../i18n/localeContext";
import { StrapiError } from "../../StrapiError";
import { _translateValue } from "../../admin-pages/translation-gestor/translateValue";
// import { useGetCareersByStudentIdMutation } from "src/services";
// import { useSelector } from "react-redux";
// import { RootState } from "src/core/store/store";

const { Content } = Layout;
const SCREEN_NAME = "PantallaSubjects";

interface ISpecificCourse extends ISubject {
  seccionId: number;
  periodoId: number;
  puedeRetirar: boolean;
  puedeCambiarSeccion: boolean;
}

// interface ICancellationData {
//   id: string;
//   opcion: string;
// }
// interface ICancellationInfo {
//   puedeAnular: boolean;
//   periodos: ICancellationData[];
// }

const Subjects: React.FC = () => {
  const [getSubjects, { data, isLoading }] = useGetCurrentSubjectsDetailMutation();
  const [getCancellationInfo, { data: cancellationInfo, isLoading: cancellationInfoLoading }] =
    useGetCancellationInfoMutation();
  const [getSubjectsForChange, { data: subjectsForChange, isLoading: isLoadingSubjectsForChange }] =
    useGetSubjectsForChangeMutation();
  const [changeSubject, { isSuccess: isSuccessChange, error: errorChange }] =
    useChangeSubjectMutation();
  const [getWithdrawMessage] = useGetWithdrawMessageMutation();
  const [
    withdrawSubject,
    { isLoading: isLoadingWithdraw, isSuccess: isSuccessWithdraw, error: errorWithdraw },
  ] = useWithdrawSubjectMutation();
  const [
    withdrawEnrollment,
    {
      isLoading: isLoadingWithdrawEnrollment,
      isSuccess: isSuccessWithdrawEnrollment,
      error: errorWithdrawEnrollment,
    },
  ] = useWithdrawEnrollmentByStudentMutation();
  const [getResolutions, { isLoading: isLoadingResolutions, data: dataResolutions }] =
    useGetResolutionsMutation();
  const [modal, contextHolder] = Modal.useModal();

  const [materiaParaRetiro, setMateriaParaRetiro] = useState<ISpecificCourse>();
  // const [anulacionMatricula, setAnulacionMatricula] = useState<ICancellationInfo>();
  const [resolucionId, setResolucionId] = useState();
  const [cancellationPeriodId, setCancellationPeriodId] = useState();
  const [mensajeRetiro, setMensajeRetiro] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalCancellationOpen, setIsModalCancellationOpen] = useState(false);
  const [modalConfirmCancellation, setModalConfirmCancellation] = useState(false);
  const [modalSelectionOpen, setModalSelectionOpen] = useState(false);
  const [subjectChangeParams, setSubjectChangeParams] = useState<any>({});
  const { locale } = useLocale();
  const [enrolledSubjectPage, setEnrolledSubjectPage] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  const [hasError, setHasError] = useState<boolean>(false);
  const showErrorSelectWithdrawalReasonToast = useErrorSelectWithdrawalReasonToast();
  const [translatedData, setTranslatedData] = React.useState<{
    asignaturas: { [key: string]: string };
  }>({
    asignaturas: {},
  });
  const showErrorSelectPeriodToast = useErrorSelectPeriodToast();
  const showSuccessSubjectWithdrawnToast = useSuccessSubjectWithdrawnToast();
  const showSuccessEnrollmentCancelledToast = useSuccessEnrollmentCancelledToast();
  const showSuccessSectionChangedToast = useSuccessSectionChangedToast();
  // const { userInfo } = useSelector((state: RootState) => state.user);
  // const [getCareers, { data: careers }] = useGetCareersByStudentIdMutation();
  // const [carreraId, setCarreraId] = React.useState();

  // useEffect(() => {
  //   getCareers(userInfo.id);
  // }, [userInfo, getCareers]);

  // useEffect(() => {
  //   if (careers?.data?.length == 1) {
  //     setCarreraId(careers?.data[0].carreraId);
  //   }
  // }, [careers]);

  const resolutionsOptions = ArrayUtils.selectLabelValue(
    dataResolutions?.data ?? [],
    "resolucionNombre",
    "resolucionId",
  );
  const cancellationPeriods = ArrayUtils.selectLabelValue(
    cancellationInfo?.data?.periodos ?? [],
    "opcion",
    "id",
  );

  useEffect(() => {
    // if (carreraId) {
    getSubjects();
    getCancellationInfo();
    // }
    getResolutions();
  }, [
    getSubjects,
    getResolutions,
    isSuccessWithdraw,
    isSuccessChange,
    getCancellationInfo,
    isSuccessWithdrawEnrollment,
  ]);

  useEffect(() => {
    if (isSuccessWithdraw) {
      showSuccessSubjectWithdrawnToast();
      setIsModalOpen(false);
    }
  }, [isSuccessWithdraw, showSuccessSubjectWithdrawnToast]);

  useEffect(() => {
    if (isSuccessWithdrawEnrollment) {
      showSuccessEnrollmentCancelledToast();
      setIsModalCancellationOpen(false);
    }
  }, [isSuccessWithdrawEnrollment, showSuccessEnrollmentCancelledToast]);

  useEffect(() => {
    if (errorWithdraw) {
      toast.error(
        errorWithdraw?.data?.message ?? JSON.parse(errorWithdraw?.data)?.message,
        toastErrorStyle,
      );
    }
  }, [errorWithdraw]);

  useEffect(() => {
    if (errorWithdrawEnrollment) {
      toast.error(
        errorWithdrawEnrollment?.data?.message ??
          JSON.parse(errorWithdrawEnrollment?.data)?.message,
        toastErrorStyle,
      );
    }
  }, [errorWithdrawEnrollment]);
  useEffect(() => {
    if (isSuccessChange) {
      setModalSelectionOpen(false);
      setSubjectChangeParams({});
      showSuccessSectionChangedToast();
    }
  }, [isSuccessChange, showSuccessSectionChangedToast]);

  useEffect(() => {
    if (errorChange) {
      setModalSelectionOpen(false);
      setSubjectChangeParams({});
      toast.error(
        errorChange?.data?.message ?? JSON.parse(errorChange?.data)?.message,
        toastErrorStyle,
      );
    }
  }, [errorChange]);

  useEffect(() => {
    if (materiaParaRetiro) {
      getWithdrawMessage(materiaParaRetiro.seccionId).then((mensaje: any) =>
        setMensajeRetiro(mensaje?.data?.data),
      );
    }
  }, [materiaParaRetiro, getWithdrawMessage]);

  useEffect(() => {
    if (mensajeRetiro && materiaParaRetiro) {
      setIsModalOpen(true);
    }
  }, [mensajeRetiro, materiaParaRetiro]);

  useEffect(() => {
    if (isModalOpen == false) {
      setMateriaParaRetiro(undefined);
      setResolucionId(undefined);
    }
  }, [isModalOpen]);

  // Efecto para traducir los campos traducibles cuando lleguen los datos o cambie el locale
  useEffect(() => {
    const translateData = async () => {
      const hasData = data?.data && Array.isArray(data.data) && data.data.length > 0;
      if (!hasData) {
        setTranslatedData({ asignaturas: {} });
        return;
      }

      const asignaturasTranslations: { [key: string]: string | null } = {};
      const translationPromises: Promise<void>[] = [];

      data.data.forEach((record: ISpecificCourse) => {
        if (record.asignaturaNombre && !asignaturasTranslations.hasOwnProperty(record.asignaturaNombre)) {
          asignaturasTranslations[record.asignaturaNombre] = null;
          translationPromises.push(
            _translateValue(SCREEN_NAME, record.asignaturaNombre, locale).then((translated) => {
              asignaturasTranslations[record.asignaturaNombre] = translated;
            })
          );
        }
      });

      await Promise.all(translationPromises);
      setTranslatedData({
        asignaturas: asignaturasTranslations as { [key: string]: string },
      });
    };
    translateData();
  }, [data?.data, locale]);

  const getSesion = (monedaId: number) => {
    return monedaId === 2 ? "₡" : "$";
  };

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setEnrolledSubjectPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 3000);
    getEnrolledSubjectPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          clearTimeout(timeoutId);
          setEnrolledSubjectPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          clearTimeout(timeoutId);
          setEnrolledSubjectPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  const columns = React.useMemo<ColumnsType<ISpecificCourse>>(
    () => [
      {
        title: enrolledSubjectPage?.enrolled_subject_table?.[0]?.label || "Código",
        dataIndex: "asignaturaCodigo",
      },
      {
        title: enrolledSubjectPage?.enrolled_subject_table?.[1]?.label || "Asignatura",
        dataIndex: "asignaturaNombre",
        render: (text: string) => translatedData.asignaturas[text] || text,
      },
      {
        title: enrolledSubjectPage?.enrolled_subject_table?.[2]?.label || "Créditos",
        dataIndex: "creditos",
      },
      {
        title: enrolledSubjectPage?.enrolled_subject_table?.[3]?.label || "Sección",
        dataIndex: "asignaturaSeccionCodigo",
      },
      {
        title: enrolledSubjectPage?.enrolled_subject_table?.[4]?.label || "Horario",
        dataIndex: "horarios",
      },
      {
        title: enrolledSubjectPage?.enrolled_subject_table?.[5]?.label || "Periodo",
        dataIndex: "periodoName",
        width: 100,
      },
      {
        title: "",
        dataIndex: "asignaturaId",
        fixed: "right",
        width: 100,
        render: (_, item) =>
          item.puedeRetirar ? (
            <Button
              type="text"
              loading={isLoadingResolutions}
              onClick={() => setMateriaParaRetiro(item)}
              style={{ borderColor: "#dc3e3e", color: "#dc3e3e" }}
            >
              {enrolledSubjectPage?.withdraw_button || "Retirar"}
            </Button>
          ) : null,
      },
      {
        title: "",
        dataIndex: "asignatura",
        fixed: "right",
        width: 200,
        render: (_, item) =>
          item.puedeCambiarSeccion ? (
            <ButtonAlternativeStyled
              type="text"
              onClick={() => {
                setModalSelectionOpen(true);
                getSubjectsForChange({ periodoId: item.periodoId, seccionId: item.seccionId });
                setSubjectChangeParams({
                  seccionViejaId: item.seccionId,
                  periodoId: item.periodoId,
                  seccionNuevaId: 0,
                });
              }}
            >
              {enrolledSubjectPage?.chance_button || "Cambiar sección"}
            </ButtonAlternativeStyled>
          ) : null,
      },
    ],
    [setModalSelectionOpen, getSubjectsForChange, isLoadingResolutions, enrolledSubjectPage, translatedData],
  );

  if (hasError && locale === 'en') {
    return <StrapiError
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setEnrolledSubjectPage(null);
      }}
    />;
  }

  return (
    <Flex style={{ flexDirection: "column", width: "100%", alignSelf: "flex-start" }}>
      {isLoadingContent ? (
        <>
          <SectionHeaderStyled>
            <Skeleton.Input active size="large" style={{ width: 200, marginBottom: 16 }} />
            <Skeleton.Input active size="default" style={{ width: 100 }} />
          </SectionHeaderStyled>
          <Content style={{ marginTop: "16px" }}>
            <Card bodyStyle={{ padding: 0, width: "100%" }}>
              <Skeleton active paragraph={{ rows: 8 }} />
            </Card>
          </Content>
        </>
      ) : (
        <>
          <SectionHeaderStyled>
            <LargeHeadingStyled>{enrolledSubjectPage?.title || "Asignaturas inscritas"}</LargeHeadingStyled>
            {/* <Form.Item label="Filtro por carrera">
              <Select
                allowClear
                value={carreraId}
                options={careers?.data?.map((c: any) => ({
                  label: c.carreraNombre,
                  value: c.carreraId,
                }))}
                onChange={(value) => {
                  setCarreraId(value);
                }}
                placeholder="Seleccione una carrera"
              />
            </Form.Item> */}

            {cancellationInfo?.data?.puedeAnular && (
              <Button
                type="text"
                loading={cancellationInfoLoading}
                onClick={() => setModalConfirmCancellation(true)}
                style={{ borderColor: "#dc3e3e", color: "#dc3e3e" }}
              >
                {enrolledSubjectPage?.anulate_button || "Anular matrícula"}
              </Button>
            )}
          </SectionHeaderStyled>
          <Content style={{ marginTop: "16px" }}>
            <Card bodyStyle={{ padding: 0, width: "100%" }}>
              <Table<ISpecificCourse>
                locale={{
                  emptyText: (
                    <Box>
                      <Box>
                        <SmallHeadingStyled>
                          {enrolledSubjectPage?.empty_message || "No se encontraron asignaturas inscritas"}
                          {/* {carreraId
                            ? "No se encontraron asignaturas inscritas"
                            : "Seleccione una carrera para mostrar las asignaturas correspondientes"} */}
                        </SmallHeadingStyled>
                        <Image
                          src={NoResultsSVG}
                          preview={false}
                          alt="Ilustración sin resultados"
                          width={200}
                        />
                      </Box>
                    </Box>
                  ),
                }}
                loading={isLoading || isLoadingWithdraw || isLoadingWithdrawEnrollment}
                columns={columns}
                dataSource={data?.data}
                rowKey={(v) => `${v.asignaturaCodigo} ${v.asignaturaNombre}`}
                pagination={{
                  defaultPageSize: 5,
                  showSizeChanger: true,
                  style: { marginRight: "30px" },
                }}
                scroll={{ x: 800 }}
              />
            </Card>
          </Content>
        </>
      )}
      <Modal
        title= {isLoadingContent ? <Skeleton.Input active size="large" style={{ width: 400 }} /> : (`${enrolledSubjectPage?.withdraw_confirm_title_prefix || "¿Está seguro(a) de que desea retirar la asignatura de"} ${materiaParaRetiro?.asignaturaNombre}?`)}
        cancelText={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (enrolledSubjectPage?.cancel_button || "Cancelar")}
        okText={enrolledSubjectPage?.withdraw_confirm_button || "Retirar asignatura"}
        confirmLoading={isLoadingWithdraw}
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
        }}
        onOk={() => {
          if (resolucionId === undefined) {
            showErrorSelectWithdrawalReasonToast();
          } else {
            withdrawSubject({
              seccionId: materiaParaRetiro?.seccionId,
              resolucionId: resolucionId,
            });
          }
        }}
        closable={false}
      >
        <div>
          <Form.Item label={enrolledSubjectPage?.reason_label || "Motivo de retiro"}>
            <Select
              value={resolucionId}
              loading={isLoadingResolutions}
              options={resolutionsOptions}
              placeholder={enrolledSubjectPage?.reason_placeholder || "Seleccione un motivo"}
              onChange={(e) => {
                setResolucionId(e);
              }}
            />
          </Form.Item>
          <p>{mensajeRetiro}</p>
        </div>
      </Modal>
      <Modal
        width="fit-content"
        closable={false}
        open={modalSelectionOpen}
        onCancel={() => setModalSelectionOpen(false)}
        okText={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (enrolledSubjectPage?.confirm_button || "Guardar Sección")}
        onOk={() => changeSubject(subjectChangeParams)}
        okButtonProps={{ disabled: subjectChangeParams.seccionNuevaId == 0 }}
        cancelText={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (enrolledSubjectPage?.cancel_button || "Cancelar")}
        title={isLoadingContent ? <Skeleton.Input active size="large" style={{ width: 400 }} /> : (`${enrolledSubjectPage?.change_section_title_prefix || "Cambio de la sección de la asignatura"} ${subjectsForChange?.data[0]?.asignaturaNombre}`)}
      >
        {" "}
        <SubjectTableSchedule
          isLoading={isLoadingSubjectsForChange}
          secciones={subjectsForChange?.data[0]?.secciones?.map((sc: any) => {
            const cupo: string = sc.cupo;
            return {
              ...sc,
              cupo,
              seccionPrecio: `${getSesion(
                subjectsForChange?.data?.monedaId ?? 2,
              )} ${FormatterUtils.number((sc.seccionPrecio as number)?.toFixed(2))}`,
              acciones: (
                <Button
                  type="link"
                  disabled={cupo === "lleno" || cupo == "0" || cupo === "Indefinido"}
                  onClick={() =>
                    setSubjectChangeParams({
                      ...subjectChangeParams,
                      seccionNuevaId:
                        subjectChangeParams.seccionNuevaId == sc.seccionId ? 0 : sc.seccionId,
                    })
                  }
                >
                  {subjectChangeParams.seccionNuevaId == sc.seccionId
                    ? enrolledSubjectPage?.remove_selection_label || "Remover selección"
                    : enrolledSubjectPage?.select_label || "Seleccionar"}
                </Button>
              ),
            };
          })}
        />
      </Modal>

      <Modal
        title={isLoadingContent ? <Skeleton.Input active size="large" style={{ width: 400 }} /> : (enrolledSubjectPage?.subtitleO || "Anulación de matrícula")}
        cancelText={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (enrolledSubjectPage?.optionN || "No")}
        okText={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (enrolledSubjectPage?.optionY || "Si")}
        open={modalConfirmCancellation}
        onCancel={() => {
          setModalConfirmCancellation(false);
        }}
        onOk={() => {
          setModalConfirmCancellation(false);
          setIsModalCancellationOpen(true);
        }}
        closable={false}
      >
        <div>
          <p>
            {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 400 }} /> : (enrolledSubjectPage?.pagraph1 || "Si ud procede con la anulación hará un retiro de <b>TODAS</b> las materias matriculadas en el periodo y se le reconocerá el 100% de lo pagado, que incluye la matrícula y el tecnofee. Puede volver a matricular, pero no se le garantiza cupo.")}
          </p>
          <p>{isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 400 }} /> : (enrolledSubjectPage?.question || "¿Está seguro que desea continuar?")}</p>
        </div>
      </Modal>
      <Modal
        title={isLoadingContent ? <Skeleton.Input active size="large" style={{ width: 400 }} /> : (enrolledSubjectPage?.subtitleO || "Anulación de matrícula")}
        cancelText={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (enrolledSubjectPage?.cancel_button || "Cancelar")}
        okText={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (enrolledSubjectPage?.confirm_button || "Confirmar")}
        confirmLoading={isLoadingWithdrawEnrollment}
        open={isModalCancellationOpen}
        onCancel={() => {
          setIsModalCancellationOpen(false);
        }}
        onOk={() => {
          if (cancellationPeriodId === undefined) {
            showErrorSelectPeriodToast();
            return false;
          }
          modal.confirm({
            title: enrolledSubjectPage?.cancel_enrollment_confirm_title || `Confirmar anulación`,
            icon: <Icon name="" color="#FFC53D" />,
            content: enrolledSubjectPage?.cancel_enrollment_confirm_content || `¿Confirma el proceso de anulación?`,
            okText: isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (enrolledSubjectPage?.optionY || "Si"),
            onOk: () => {
              withdrawEnrollment({
                cancellationPeriodId: cancellationPeriodId,
              });
            },
            cancelText: isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (enrolledSubjectPage?.optionN || "No"),
            style: { top: 200, zIndex: 2000 },
          });
        }}
        closable={false}
      >
        <div>
          <Form.Item label={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (enrolledSubjectPage?.course || "Carrera")} layout="vertical">
            <Select
              value={cancellationPeriodId}
              loading={cancellationInfoLoading}
              options={cancellationPeriods}
              placeholder={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (enrolledSubjectPage?.select_option || "Seleccionar carrera")}
              onChange={(e) => {
                setCancellationPeriodId(e);
              }}
            />
          </Form.Item>
        </div>
      </Modal>
      {contextHolder}
    </Flex>
  );
};

export default Subjects;
